var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8919 25L48.7793 7.11263C50.4069 5.48503 50.4069 2.84831 48.7793 1.2207C47.1517 -0.406901 44.515 -0.406901 42.8874 1.2207L25 19.1081L7.11263 1.2207C5.48503 -0.406901 2.84831 -0.406901 1.2207 1.2207C-0.406901 2.84831 -0.406901 5.48503 1.2207 7.11263L19.1081 25L1.2207 42.8874C-0.406901 44.515 -0.406901 47.1517 1.2207 48.7793C2.03451 49.5931 3.10059 50 4.16667 50C5.23275 50 6.29883 49.5931 7.11263 48.7793L25 30.8919L42.8874 48.7793C43.7012 49.5931 44.7673 50 45.8333 50C46.8994 50 47.9655 49.5931 48.7793 48.7793C50.4069 47.1517 50.4069 44.515 48.7793 42.8874L30.8919 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.20a1cb12a5811131389a4d1e65b2bf50.svg";
export { ForwardRef as ReactComponent };